import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-scheduled-end-date';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Scheduled end date/time',
};

const sstScheduledEndDate = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstScheduledEndDate };
